import LinkIcon from './Link'
import HistoryIcon from './History'
import FavoriteIcon from './Favorite'
import UnFavoriteIcon from './UnFavorite'
import ProductDocumentsIcon from './ProductDocuments'
import StarIcon from './Star'
const Misc = {
    LinkIcon,
    HistoryIcon,
    FavoriteIcon,
    UnFavoriteIcon,
    ProductDocumentsIcon,
    StarIcon
}
export default Misc
